// components/sections/Demo.js
import React from 'react';
import styled from 'styled-components';
import Container from '../common/Container';
import { SectionTitle, SectionSubtitle } from '../common/SharedStyles';

const TutorialGrid = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4rem;

  @media (max-width: 768px) {
    gap: 2rem;
  }
`;

const VideoContainer = styled.div`
  position: relative;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: var(--card-shadow);
  width: 80%;
  max-width: 800px;

  &::before {
    content: '';
    display: block;
    padding-top: 56.25%; // 16:9 aspect ratio
  }

  iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border: 0;
  }
`;



const Demo = () => {
    return (
        <section id="demo">
            <Container>
                <SectionTitle>Demo Video</SectionTitle>
                <SectionSubtitle>
                    See exactly how Sivo helps you save time and money.
                </SectionSubtitle>

                <TutorialGrid>
                    <VideoContainer>
                        <iframe
                            src="https://www.youtube.com/embed/MNjQ_clNqcA"
                            title="Sivo Demo Video"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowFullScreen
                        />
                    </VideoContainer>
                </TutorialGrid>
            </Container>
        </section>
    );
};

export default Demo;
